export enum IncentiveTrigger {
  OneTime = 0,
  //HOS
  IfShiftStart = 1,
  PerShiftStart = 2,

  //Log
  PerDay = 10,
  PerDepartureDelay = 11,
  PerReRouteDelay = 12,
  DayCount = 13
}

export const IncentiveTriggerMapping: Record<IncentiveTrigger, string> = {
  [IncentiveTrigger.OneTime]: 'Once Per Interval',
  [IncentiveTrigger.IfShiftStart]: 'If Shift Start During',
  [IncentiveTrigger.PerShiftStart]: 'Per Shift Start',
  [IncentiveTrigger.PerDay]: 'Per Day',
  [IncentiveTrigger.PerDepartureDelay]: 'Per Departure Delay',
  [IncentiveTrigger.PerReRouteDelay]: 'Per ReRoute Delay',
  [IncentiveTrigger.DayCount]: 'Day Count'
};
